import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { PermissionVinculadasModel } from 'app/model/permission/permissionvinculadas.model';
import { GroupModel } from './../../model/permission/group.model';
import { RoleModel } from './../../model/usuario/role.model';
import { PermissionModel } from './../../model/permission/permission.model';
import { GrupoPermissionModel } from './../../model/permission/grupopermission.model';
import { GrupoProdutoModel } from './../../model/produto/grupo-produto.model';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';
import { GrupoVinculadoModel } from 'app/model/permission/grupovinculado.model';
import * as CryptoJS from 'crypto-js';
import { ClienteMinModel } from 'app/model/cliente/clienteMin.model';

interface GrupoPermissaoMap {
  hasParamInstance: string;
  permissaoVinculadas: GrupoVinculadoModel[]
}
@Injectable()
export class PermissionsService {

  apiURL = environment.API;
  apiAlfresco = environment.AlfrescoAPI;
  apiURLPublic = environment.APIpublic;
  arrayString: string;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpCliente: HttpClient) { }

  getIsLogged(ticket) {
    const headers = new HttpHeaders()
      .set('Authorization', 'Basic ' + btoa(ticket));
    return this.httpCliente.get(this.apiAlfresco + '/alfresco/api/-default-/public/authentication/versions/1/tickets/-me-', { headers, responseType: 'text'});
  }

  getUsuariosRM(page: number, size : number): Observable<ResponsePageable> {
    return this.httpCliente.get<ResponsePageable>(this.apiURLPublic + `/usuarios/listar?page=${page}&size=${size}`, this.httpOptions);
  }

  getGruposPermissions(): Observable<Array<GrupoPermissionModel>> {
    return this.httpCliente.get<Array<GrupoPermissionModel>>(this.apiURL + '/view/listar-grupo-permissao-usuario', this.httpOptions);
  }

  getAllGrupos(): Observable<Array<GrupoPermissionModel>> {
    return this.httpCliente.get<Array<GrupoPermissionModel>>(this.apiURL + '/view/listar-grupo-permissao', this.httpOptions);
  }

  getPermissionsGrupo(id: number): Observable<Array<PermissionModel>> {
    return this.httpCliente.get<Array<PermissionModel>>(this.apiURL + `/view/listar-permission-grupo/${id}`, this.httpOptions);
  }

  getPermissionByIdGrupo(groupId: number): Observable<Array<any>> {
    return this.httpCliente.get<Array<any>>(this.apiURL + `/listar-permission-id-grupo/${groupId}`, this.httpOptions);
  }

  getAllGroups(): Observable<Array<GroupModel>> {
    return this.httpCliente.get<Array<GroupModel>>(this.apiURL + '/view/listar-group-permission', this.httpOptions);
  }

  getGrupoUnico(id: number): Observable<GrupoPermissionModel> {
    return this.httpCliente.get<GrupoPermissionModel>(this.apiURL + `/view/listar-grupo-unico/${id}`, this.httpOptions);
  }

  getPermissionGroup(idGroup: number): Observable<Array<PermissionModel>> {
    return this.httpCliente.get<Array<PermissionModel>>(this.apiURL + `/view/listar-permissions-group/${idGroup}`, this.httpOptions);
  }

  getAllPermissions(): Observable<Array<PermissionModel>> {
    return this.httpCliente.get<Array<PermissionModel>>(this.apiURL + '/view/listar-all-permissions', this.httpOptions);
  }

  adicionarGrupoPermission(grupo: GrupoPermissionModel): Observable<GrupoPermissionModel> {
    return this.httpCliente.post<GrupoPermissionModel>(this.apiURL + '/new/adicionar-grupo-permissao', grupo, this.httpOptions);
  }

  editarGrupoPermission(grupo: GrupoPermissionModel): Observable<GrupoPermissionModel> {
    return this.httpCliente.put<GrupoPermissionModel>(this.apiURL + '/edit/editar-grupo-permissao', grupo, this.httpOptions);
  }

  apagarGrupo(idGrupo: number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpCliente.delete(this.apiURL + `/delete/apagar-grupo-permissao/${idGrupo}`, { headers, responseType: 'text'});
  }docker

  listPermissoesVinculadosGrupo(idGrupo: number): Observable<GrupoPermissaoMap> {
    return this.httpCliente.get<GrupoPermissaoMap>(this.apiURL + `/view/permission-list/${idGrupo}`, this.httpOptions);
  }

  verificarInstancia(): Observable<any> {
    return this.httpCliente.post<any>(this.apiURL + `/verify-has-param-instance`, this.httpOptions);
  }

  getItemAuthority() {
    const store = sessionStorage.getItem('authority');
    const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
    this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return this.httpCliente.get(this.arrayString);
  }

  getAllClientsMin(): Observable<Array<ClienteMinModel>> {
    return this.httpCliente.get<Array<ClienteMinModel>>(this.apiURL + '/find-all-clientes-min/', this.httpOptions);
  }

  getUsersByClientPermissionGroup(idClient: number, idGroup: number): Observable<any[]> {
    return this.httpCliente.get<any[]>(
      this.apiURL + `/usuarios/get-users-by-client-permission-group/${idClient}/${idGroup}`, this.httpOptions
    );
  }

  saveUsersToGroup(usersAuthToSave, clientId, roleId): Observable<any> {
    let usersAuthToSavejson = JSON.stringify(usersAuthToSave);

    return this.httpCliente.post<any>(
      this.apiURL + `/group-permission/add-users/${clientId}/${roleId}`, usersAuthToSavejson, this.httpOptions
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/permission/permissions.service.ts